import { useCallback } from 'react';

import useRequestJSON, {
  IsLoadingSegment,
  RunnerSegment
} from './hooks/useRequestJSON';
import { PostJSON } from './request';
import { ISurveyQual } from './apps/surveyqual';

export interface GetSurveyResponse {
  status: 'OK' | 'FAIL';
  survey: ISurveyQual;
  routes: {
    call: string;
    message: string;
  };
  message?: string;
}

export const useGetSurvey = (
  patientId: number
): Omit<GetSurveyResponse, 'status'> & RunnerSegment & IsLoadingSegment => {
  // Get the survey information
  const url = '/survey/edit/';
  const request = useCallback(
    () =>
      PostJSON({
        url: url,
        params: {
          patientId: patientId,
          isEditing: false
        }
      }),
    [patientId]
  );
  const { data, run, isLoading } = useRequestJSON<
    GetSurveyResponse,
    Omit<GetSurveyResponse, 'status'>
  >({ request });
  return {
    survey: data?.survey,
    routes: data?.routes,
    isLoading,
    run: () => run(request)
  };
};
